import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Sentry from '@sentry/browser';
import { getDay, fromNow } from '../../../services/dates';

// lodash
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _throttle from 'lodash/throttle';

import {
	updateItemCount,
	selectListItem,
	setLastCountedItem,
	setCountArea,
	setSuggestedItems,
	setFetchingData,
	resetState,
	setSearch,
	clearSearch,
	setDate,
	moveEditedToCounted,
	setActiveCountArea,
	setCountVersion,
	clearSelected,
} from './store/countPage.actions';
import {
	fetchProducts,
	executeRecount,
	fetchTempCount,
	postTempCount,
} from './store/countPage.service';
import { signCountArea } from './../areasList/store/areasList.actions';
import LoaderPage from '../../loaderPage/loaderPage.component';
import CountPage from './countPage.component';
import { Button, Loader, Modal } from '@dumb';
import { Navigation } from '@smart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Services
import toast from '@dumb/toast/toast';
import formatErrorMessage from '../../../services/formatErrorMessage';
import history from '../../../routerHistory';

class CountPageContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isExecutingTask: false,
			showVersionHistoryModal: false,
			confirmModal: false,
			fetchingTempCounts: false,
			offloadedTempCounts: [],
			itemBeingSet: {},
		};

		this.onSign = this.onSign.bind(this);
		this.setUpCountAreaData = this.setUpCountAreaData.bind(this);
		this.handleSetCountVersionConfirm =
			this.handleSetCountVersionConfirm.bind(this);
		this.handleConfirmSet = this.handleConfirmSet.bind(this);
		this.toggleConfirmModal = this.toggleConfirmModal.bind(this);
		this.toggleVersionHistoryModal = this.toggleVersionHistoryModal.bind(this);
		this.onBackClick = this.onBackClick.bind(this);
		this.getSelect = this.getSelect.bind(this);
		this.openHistoryModal = this.openHistoryModal.bind(this);
		this.offloadToTempStorage = _throttle(
			this.offloadToTempStorage.bind(this),
			60000 * 5 // every 5 minutes
		);
	}

	componentDidMount() {
		const { match, countAreas, selectedTaskDetails, setActiveCountArea } =
			this.props;

		const areaId = match.params.areaId ?? 'pastCount';
		setActiveCountArea(selectedTaskDetails.taskId, areaId);

		const area = countAreas.find((x) => x.id === Number(areaId));

		this.props.setDate(selectedTaskDetails.date);
		this.setUpCountAreaData(area, selectedTaskDetails);
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.countedList) ===
			JSON.stringify(this.props.countedList)
		)
			return;

		if (Object.keys(this.props.countedList).length < 1) return;
		this.offloadToTempStorage();
	}

	offloadToTempStorage() {
		const {
			selectedTaskDetails,
			countForEntireTask,
			selectedWorkplace,
			lastCountedItem,
		} = this.props;

		const count = Object.keys(countForEntireTask).reduce((acc, key) => {
			return {
				...acc,
				[key]: countForEntireTask[key].counted,
			};
		}, {});

		const numberOfCountedItems = Object.keys(count).reduce((acc, key) => {
			return acc + Object.keys(count[key]).length;
		}, 0);

		const meta = {
			lastUpdate: getDay().format('YYYY-MM-DDTHH:mm'),
			lastCountedItem: lastCountedItem,
			taskId: this.props.taskId,
			areaId: this.props.areaId,
			numberOfCountedItems,
		};

		postTempCount(
			selectedTaskDetails,
			{
				meta: JSON.stringify(meta),
				count: JSON.stringify(count),
			},
			selectedWorkplace
		);
	}

	/**
	 * @function setUpCountAreaData
	 * @description This is used in order to setup the page data, is called in componentDidMount
	 * @param {object} area count areas name and details
	 * @param {object} selectedTaskDetails
	 */
	async setUpCountAreaData(area, selectedTaskDetails) {
		const {
			setCountArea,
			setSuggestedItems,
			setFetchingData,
			selectedWorkplace,
		} = this.props;

		setFetchingData(true);

		// Sets count area thats is selected (from uri and redux)

		const countAreaPayload =
			selectedTaskDetails.status === 'executed'
				? { name: 'Count review' }
				: area;

		setCountArea(countAreaPayload);

		// Fetch API data11
		fetchProducts(selectedTaskDetails, selectedWorkplace)
			.then((items) => {
				setSuggestedItems({
					area,
					data: items.data,
					id: selectedTaskDetails.taskId,
				});

				setFetchingData(false);
			})
			.catch((error) => {
				toast.show(`Error: ${error.message}`, 'error', 3000);
				setFetchingData(false);
			});
		// });
	}

	executeRecount() {
		const {
			selectedTaskDetails,
			countedList,
			selectedWorkplace,
			suggestionsList,
		} = this.props;

		if (Object.keys(countedList).length === 0) {
			toast.show('You have not modified any count!', 'warning', 3000);
			return;
		}
		this.setState({ isExecutingTask: true });
		var itemsList = Object.assign({}, countedList, suggestionsList);

		executeRecount(selectedTaskDetails, itemsList, selectedWorkplace)
			.then(() => {
				this.setState({ isExecutingTask: false });
				history.push({
					pathname: '/tasks/counts/confirmation',
					state: { transition: 'slide-left', duration: 150 },
				});

				// resetState();
			})
			.catch((error) => {
				this.setState({ isExecutingTask: false });
				toast.show(formatErrorMessage(error), 'error', 3000);
			});
	}

	onSign() {
		if (this.props.selectedTaskDetails.status !== 'executed') {
			// signAreaCount((this.props.taskId, this.props.areaId));
			this.props.signCountArea({
				taskId: this.props.taskId,
				areaId: this.props.areaId,
			});
			this.props.moveEditedToCounted();
			history.push({
				pathname: '/tasks/areas/overview',
				state: { transition: 'slide-left', duration: 150 },
			});
		} else {
			// this.props.moveEditedToCounted();
			this.executeRecount();
		}
	}

	onBackClick() {
		const { location, moveEditedToCounted } = this.props;
		// move last edited if needed
		moveEditedToCounted();

		const pathName = '/tasks/areas';

		const path = _get(location, 'state.from', '');
		if (path === '/tasks/areas/overview') {
			history.push({
				pathname: pathName,
				state: { transition: 'slide-right', duration: 150 },
			});
		} else {
			history.goBack();
		}
	}

	handleCountAreaChange(e) {
		history.replace({
			pathname: `/tasks/count/${e.target.value}`,
			state: { duration: 50 },
		});
	}

	toggleVersionHistoryModal() {
		this.setState((prevState) => ({
			showVersionHistoryModal: !prevState.showVersionHistoryModal,
		}));
	}

	toggleConfirmModal() {
		this.setState((prevState) => ({
			confirmModal: !prevState.confirmModal,
		}));
	}

	async openHistoryModal() {
		const { selectedTaskDetails, selectedWorkplace } = this.props;

		this.toggleVersionHistoryModal();

		this.setState(() => ({
			offloadedTempCounts: [],
			fetchingTempCounts: true,
		}));
		let offloadedTempCounts;
		try {
			const { data } = await fetchTempCount(
				selectedTaskDetails,
				selectedWorkplace
			);

			offloadedTempCounts = data;
		} catch (error) {
			Sentry.withScope((scope) => {
				scope.setExtra('error', error);
				Sentry.captureMessage('Something went wrong fetchTempCount  ', 'info');
			});
		}

		this.setState(() => ({
			offloadedTempCounts,
			fetchingTempCounts: false,
		}));
	}

	getSelect() {
		const { countArea, countAreas } = this.props;

		return (
			<div className="count-page__select-wrapper">
				<select
					className="count-page__select-wrapper__select"
					value={countArea?.id}
					onChange={this.handleCountAreaChange}
				>
					{_isArray(countAreas) &&
						countAreas.map((entry, index) => (
							<option key={index} value={entry.id}>
								{entry.name}
							</option>
						))}
				</select>
			</div>
		);
	}

	handleConfirmSet(countVersion) {
		this.toggleConfirmModal();
		this.setState({ itemBeingSet: countVersion });
	}

	handleSetCountVersionConfirm() {
		const { itemBeingSet } = this.state;
		const { setCountVersion } = this.props;
		setCountVersion(itemBeingSet);

		this.toggleVersionHistoryModal();
		this.toggleConfirmModal();
		this.setState({ itemBeingSet: {} });
	}

	render() {
		const {
			updateItemCount,
			suggestionsList,
			countedList,
			selectListItem,
			selectedListItem,
			setLastCountedItem,
			selectedTaskDetails,
			isFetchingData,
			setSearch,
			search,
			clearSearch,
			moveEditedToCounted,
			restItems,
			clearSelected,
			listOrder,
		} = this.props;
		const {
			isExecutingTask,
			showVersionHistoryModal,
			offloadedTempCounts,
			fetchingTempCounts,
			confirmModal,
		} = this.state;

		return (
			<div>
				<Navigation
					leftContent={
						<>
							<div style={{ display: 'flex' }}>
								<div style={{ marginRight: '8px' }}>
									<Button type="text" onClick={this.onBackClick}>
										<FontAwesomeIcon icon={['fas', 'angle-left']} size="2x" />
									</Button>
								</div>
								<Button type="text" onClick={this.openHistoryModal}>
									<FontAwesomeIcon icon={['fas', 'history']} size="2x" />
								</Button>
							</div>
						</>
					}
					header={this.getSelect()}
					rightContent={
						isExecutingTask ? (
							<Loader size="tiny" active />
						) : (
							<Button
								type="text"
								onClick={this.onSign}
								disabled={isExecutingTask}
							>
								Sign
							</Button>
						)
					}
				/>
				{isFetchingData ? (
					<LoaderPage text="Fetching Products..." />
				) : (
					<CountPage
						clearSearch={clearSearch}
						suggestionsList={suggestionsList}
						countedList={countedList}
						updateItemCount={updateItemCount}
						setLastCountedItem={setLastCountedItem}
						selectListItem={selectListItem}
						selectedListItem={selectedListItem}
						selectedTaskDetails={selectedTaskDetails}
						listOrder={listOrder}
						setSearch={setSearch}
						search={search}
						moveEditedToCounted={moveEditedToCounted}
						restItems={restItems}
						clearSelected={clearSelected}
					/>
				)}

				{showVersionHistoryModal && (
					<Modal
						onClose={this.toggleVersionHistoryModal}
						isOpen={showVersionHistoryModal}
						className="version-modal"
					>
						<div className="count-page__version-modal">
							<div className="count-page__version-modal__content">
								<div className="count-page__version-modal__content__header">
									<h2 className="count-page__version-modal__content__title">
										Version History
									</h2>
									<p className="count-page__version-modal__content__description">
										Here you can roll back saved versions of your count.
									</p>
								</div>

								{fetchingTempCounts && (
									<div className="count-page__version-modal__loader">
										<Loader />
									</div>
								)}

								{offloadedTempCounts.length === 0 && !fetchingTempCounts && (
									<p className="count-page__version-modal__content__description">
										No counts stored
									</p>
								)}

								{(offloadedTempCounts || []).map((item) => {
									return (
										<VersionItem
											key={item.uuid}
											item={item}
											handleConfirmSet={this.handleConfirmSet}
										/>
									);
								})}
								<div className="count-page__version-modal__buttons">
									<Button
										type="success"
										onClick={this.toggleVersionHistoryModal}
									>
										Close
									</Button>
								</div>
							</div>
						</div>
					</Modal>
				)}

				{confirmModal && (
					<Modal
						onClose={this.toggleConfirmModal}
						isOpen={confirmModal}
						className="version-modal">
						<div className="count-page__version-modal">
							<div className="count-page__version-modal__content">
								<div className="count-page__version-modal__content__header">
									<h2 className="count-page__version-modal__content__title">
										Confirm modal
									</h2>
									<p className="count-page__version-modal__content__description">
										This will reset this entire count and all areas to that
										saved version. Are you sure you want to do that?
									</p>

									<div className="count-page__version-modal__buttons-confirm">
										<Button type="danger" onClick={this.toggleConfirmModal}>
											No
										</Button>
										<Button type="success" onClick={this.handleSetCountVersionConfirm}>
											Continue
										</Button>
									</div>
								</div>
							</div>
						</div>
					</Modal>
				)}
			</div>
		);
	}
}

const VersionItem = ({ item, handleConfirmSet }) => {
	const data = JSON.parse(item.data);
	const countMeta =
		typeof data.meta === 'string' ? JSON.parse(data.meta) : data.meta;

	return (
		<div
			className="version-item"
			onClick={() => {
				handleConfirmSet(item);
			}}>
			<span className="version-item__last-counted">
				Last counted item: {countMeta?.lastCountedItem?.product?.name ?? ''} (
				{countMeta?.lastCountedItem?.count ?? ''})
			</span>
			<div className="version-item__meta">
				<span className="version-item__meta__total-counted">
					Total number of counted products {countMeta.numberOfCountedItems}
				</span>
				<span className="version-item__meta__last-updated">
					Last updated {fromNow(countMeta.lastUpdate)}
				</span>
			</div>
		</div>
	);
};

CountPageContainer.propTypes = {
	location: PropTypes.object,
	setCountArea: PropTypes.func,
	selectListItem: PropTypes.func,
	updateItemCount: PropTypes.func,
	suggestionsList: PropTypes.object,
	countedList: PropTypes.object,
	selectedListItem: PropTypes.string,
	countArea: PropTypes.object,
	selectedTaskDetails: PropTypes.object,
	selectedWorkplace: PropTypes.object,
	lastCountedItem: PropTypes.object,
	setSuggestedItems: PropTypes.func,

	setFetchingData: PropTypes.func,
	isFetchingData: PropTypes.bool,
	taskId: PropTypes.string,

	signCountArea: PropTypes.func,
	setSearch: PropTypes.func,
	clearSearch: PropTypes.func,
	search: PropTypes.string,
	setDate: PropTypes.func,
	setLastCountedItem: PropTypes.func,
	moveEditedToCounted: PropTypes.func,
	countAreas: PropTypes.array,
	listOrder: PropTypes.array,
	restItems: PropTypes.object,
	match: PropTypes.object,
	areaId: PropTypes.number,
	countForEntireTask: PropTypes.object,
	clearSelected: PropTypes.func,
	setActiveCountArea: PropTypes.func,
	setCountVersion: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			updateItemCount,
			setCountVersion,
			selectListItem,
			setCountArea,
			setSuggestedItems,
			setLastCountedItem,
			setFetchingData,
			resetState,
			setSearch,
			signCountArea,
			clearSearch,
			setDate,
			setActiveCountArea,
			moveEditedToCounted,
			clearSelected,
		},
		dispatch
	);
};

const mapStateToProps = (state) => {
	return {
		taskId: state.count.data.taskId,
		areaId: state.count.data.areaId,
		lastCountedItem: state.count.data.lastCountedItem,
		suggestionsList:
			state.count.data?.[state.count.data?.taskId]?.[state.count.data?.areaId]
				?.suggestions,
		countedList:
			state.count.data?.[state.count.data?.taskId]?.[state.count.data?.areaId]
				?.counted ?? {},
		countForEntireTask: state.count.data?.[state.count.data?.taskId] ?? {},
		itemList:
			state.count.data?.[state.count.data?.taskId]?.[state.count.data?.areaId]
				?.itemList ?? {},
		restItems:
			state.count.data?.[state.count.data?.taskId]?.[state.count.data?.areaId]
				.restItems ?? {},
		countArea: state.count.data.countArea,
		selectedListItem: state.count.ui.selectedListItem,
		selectedTaskDetails: state.storeTasks.selectedTask,
		selectedWorkplace: state.workplaces.data.selectedWorkplace,
		isFetchingData: state.count.ui.fetchingData,
		search: state.count.ui.search,
		countAreas: state.countAreas.data.countAreas,
		listOrder: state.count.ui.listOrder,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CountPageContainer);
